import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import { injectFromApp } from "../../../inject";
import type { IThirdPartySoftwareStore } from "./ThirdPartySoftwareStore";

interface IThirdPartySoftwareComponentProps {
    resourcesStore?: IResourcesStore;
    thirdPartySoftwareStore?: IThirdPartySoftwareStore;
}
@injectFromApp<IThirdPartySoftwareComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
    thirdPartySoftwareStore: stores.thirdPartySoftwareStore,
}))

@observer
export class ThirdPartySoftwareComponent extends React.Component<IThirdPartySoftwareComponentProps> {
    private readonly toggleShowThirdPartySoftware = (e) => {
        e.preventDefault();
        const { thirdPartySoftwareStore } = this.props;
        thirdPartySoftwareStore!.toggle();
    };

    render() {
        const { resourcesStore, thirdPartySoftwareStore } = this.props;
        const { resources } = resourcesStore!;
        const { isOpen, list } = thirdPartySoftwareStore!;
        return (
            <>
                <p>
                    <a onClick={this.toggleShowThirdPartySoftware} className={"toggle-show-third-party-software"}>
                        {resources.UsedThirdPartySoftwareComponents}
                    </a>
                </p>
                {isOpen && (
                    <div className={"third-party-software"}>
                        {list.map((l) => (
                            <p key={ l.name }>
                                {l.name} | <span>{l.license}</span>
                            </p>
                        ))}
                    </div>
                )}
            </>
        );
    }
}
